export { PhoneContactInformationType } from './generated/PhoneContactInformationType.js';